import React from "react";
import "./fold.css";

const Fold3 = () => {
  return (
    <div className="fold-content">
      <div classname="setbg">
        <div className="how-it-works-container">
          <div className="section-header">
            <h2 className="section-title">How It Works</h2>
            <p className="section-subtitle">Simple 3-Step Flow</p>
          </div>

          <div className="steps-container">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3 className="step-title">Assist - Instant Claim Intake & Triage</h3>
                <ul className="step-description">
                  • AI ingests portal/app FNOL documents.
                </ul>
                <ul className="step-description">
                  • OCR extracts key data fields with 100% accuracy
                </ul>
                <ul className="step-description">
                  • Triage sets aside 70% routine claims for straight-through processing.
                </ul>
              </div>
              <div className="step-icon">
                <span className="icon">📞</span>
              </div>
            </div>

            <div className="step-connector">
              <div className="connector-line"></div>
              <div className="connector-arrow">↓</div>
            </div>

            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3 className="step-title">Augment - Guided Adjudication</h3>
                <ul className="step-description">
                  • Routine claims auto‑approved & routed for payout.
                </ul>
                <ul className="step-description">
                  • Complex claims are reviewed by adjusters with AI‑extracted data and fraud risk scores
                </ul>
              </div>
              <div className="step-icon">
                <span className="icon">💬</span>
              </div>
            </div>

            <div className="step-connector">
              <div className="connector-line"></div>
              <div className="connector-arrow">↓</div>
            </div>

            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3 className="step-title">Transform - Payout & Insights</h3>
                <ul className="step-description">
                  • Auto‑trigger payments for approved claims.
                </ul>
                <ul className="step-description">
                  • All interactions logged for auditing.
                </ul>
                <ul className="step-description">
                  • Analytics dashboard shows cycle time reduction and error rates.
                </ul>
              </div>
              <div className="step-icon">
                <span className="icon">📱</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fold3;
